const FormatDateToDDMMYY = (isoDate) => {
  if (isoDate == null || isoDate === "") return "-"; // null/undefined/""
  const date = new Date(isoDate);
  // Validar si la fecha es inválida (por ejemplo, si `isoDate` es incorrecto)
  if (isNaN(date.getTime())) {
    return "-";
  }

  date.setHours(date.getHours() - 5);

  // Ajustamos el año, mes y día para evitar la alteración por zona horaria
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Los meses van de 0-11, por eso sumamos 1
  const year = String(date.getUTCFullYear()).slice(2); // Extraemos solo los dos últimos dígitos del año

  // Formatear como dd/mm/aa
  return `${day}/${month}/${year}`;
};

const FormatDateToDDMMYYHHMM = (isoDate) => {
  const date = new Date(isoDate);

  return date.toLocaleString("es-PE", {
    timeZone: "America/Lima", // UTC-5
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false, // Formato 24 horas
  }).replace(",", " -"); // Ajustamos el formato para que coincida con tu retorno
};

const FormatTimeStamp = (timeStamp) => {
  const date = new Date(timeStamp * 1000); // Convertir de segundos a milisegundos
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Los meses van de 0 a 11
  const year = date.getFullYear().toString().slice(-2); // Tomar solo los últimos dos dígitos del año

  return `${hours}:${minutes} - ${day}/${month}/${year}`;
}

const FormatMinutesToHours = (m) => {
  const hours = Math.floor(m / 60)
  const minutes = m % 60
  return `${hours}h ${minutes}m`
}

function FormatDateString(dateString) {
  if (!dateString) return "";
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(dateString));
  if (!match) return "";
  const [, y, mm, dd] = match;
  const months = ["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"];
  const month = months[Math.max(0, Math.min(11, parseInt(mm, 10) - 1))];
  return `${dd}-${month}-${y.slice(-2)}`;
}

function FormatDateStringDDMMYYYY(dateString) {
  if (!dateString) return "";
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(dateString));
  if (!match) return "";
  const [, y, mm, dd] = match;
  const months = ["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"];
  const month = months[Math.max(0, Math.min(11, parseInt(mm, 10) - 1))];
  return `${dd}-${month}-${y}`;
}

function FormatDateTimeString(dateString) {
  if (!dateString) return "";
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  const months = {
    0: "ene",
    1: "feb",
    2: "mar",
    3: "abr",
    4: "may",
    5: "jun",
    6: "jul",
    7: "ago",
    8: "sep",
    9: "oct",
    10: "nov",
    11: "dic"
  };

  const day = date.getDate().toString().padStart(2, '0');
  const month = months[date.getMonth()];
  const year = date.getFullYear().toString().slice(-2);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${day}-${month}-${year} - ${hours}:${minutes}`;
}

// New: GMT-5 (America/Lima) helpers
function FormatDateStringGMT5(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";
  const parts = new Intl.DateTimeFormat('es-PE', {
    timeZone: 'America/Lima',
    day: '2-digit',
    month: 'short',
    year: '2-digit',
  }).formatToParts(date).reduce((acc, p) => { acc[p.type] = p.value; return acc; }, {});
  const month = String(parts.month || '').replaceAll('.', '');
  return `${parts.day}-${month}-${parts.year}`;
}

function FormatDateTimeStringGMT5(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";
  const parts = new Intl.DateTimeFormat('es-PE', {
    timeZone: 'America/Lima',
    day: '2-digit',
    month: 'short',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(date).reduce((acc, p) => { acc[p.type] = p.value; return acc; }, {});
  const month = String(parts.month || '').replaceAll('.', '');
  return `${parts.day}-${month}-${parts.year} - ${parts.hour}:${parts.minute}`;
}

// Preserve original UTC date as Lima local midnight (avoid previous-day shift)
function FormatDateTimeStringGMT5Midnight(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";
  const y = date.getUTCFullYear();
  const m = date.getUTCMonth();
  const d = date.getUTCDate();
  // 05:00 UTC corresponds to 00:00 in Lima
  const limaMidnightUTC = new Date(Date.UTC(y, m, d, 5, 0, 0));
  const parts = new Intl.DateTimeFormat('es-PE', {
    timeZone: 'America/Lima',
    day: '2-digit',
    month: 'short',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(limaMidnightUTC).reduce((acc, p) => { acc[p.type] = p.value; return acc; }, {});
  const month = String(parts.month || '').replaceAll('.', '');
  return `${parts.day}-${month}-${parts.year} - ${parts.hour}:${parts.minute}`;
}

export {
  FormatDateToDDMMYY,
  FormatDateToDDMMYYHHMM,
  FormatTimeStamp,
  FormatMinutesToHours,
  FormatDateString,
  FormatDateStringDDMMYYYY,
  FormatDateTimeString,
  FormatDateStringGMT5,
  FormatDateTimeStringGMT5,
  FormatDateTimeStringGMT5Midnight
}